import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../sync/db.js";
import type { CookSessionApiItem } from "@recipevault/shared";

export function useCookSession(id: string | undefined): CookSessionApiItem | undefined {
  return useLiveQuery(() => (id ? db.cookSessions.get(id) : undefined), [id], undefined);
}
